module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


// WEBPACK FOOTER //
// ../node_modules/babel-runtime/core-js/object/create.js